export default __webpack_public_path__ + "static/media/auth_bg.14be0e53.jpg";